module.exports = __webpack_public_path__ + "static/media/nj-law.0555d375.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/nj-law.png
// module id = 41
// module chunks = 0